import { customEvent } from "goi_common";
import { GOI_PHONE_HREF } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";
import { ArrowRightIcon } from "@/components/DirectionsIcons";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

interface DirectionsFixedBarProps {
  parlorId: number;
  companyName: string;
}

export const DirectionsFixedBar = ({
  parlorId,
  companyName,
}: DirectionsFixedBarProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("prlr_directions");
  const estimateHref = `${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/match/parlor-requests/${parlorId}/?utm_source=parlor_goi&utm_campaign=directions&utm_content=fixed_cost`;

  return (
    <div
      className="dr-fixedbar"
      role="region"
      aria-label="비용 알아보기 · 장례 상담"
    >
      <div className="dr-fixedbar__inner">
        <a
          className="dr-fixedbar__cta dr-fixedbar__cta--ghost"
          href={GOI_PHONE_HREF}
          onClick={(event) => {
            event.preventDefault();
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "i_fixed_call",
                properties: {
                  parlor_id: parlorId,
                  cta_type: "call",
                  cta_position: "fixed",
                },
              },
            });
            void openParlorInquiryModal();
          }}
        >
          <PhoneIcon size={20} style={{ marginRight: 8, flexShrink: 0 }} />
          <span className="dr-fixedbar__cta-twolines">
            <span className="dr-fixedbar__cta-line1">고이 24시간</span>
            <span className="dr-fixedbar__cta-line2">무료 장례 상담</span>
          </span>
        </a>
        <a
          className="dr-fixedbar__cta dr-fixedbar__cta--primary"
          href={estimateHref}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: "i_fixed_cost",
                properties: {
                  parlor_id: parlorId,
                  cta_type: "cost",
                  cta_position: "fixed",
                },
              },
            })
          }
        >
          <span className="dr-fixedbar__cta-stack">
            <span className="dr-fixedbar__cta-eyebrow">{companyName}</span>
            <span className="dr-fixedbar__cta-main">
              비용 알아보기
              <ArrowRightIcon size={14} style={{ marginLeft: 4 }} />
            </span>
          </span>
        </a>
      </div>
    </div>
  );
};
